import { Flex, Tooltip } from '@radix-ui/themes'
import { Link } from 'react-router-dom'
import { RouterPathes } from 'shared/constants'
import { QuestionSymbol } from 'shared/icons'
import styles from '../navigation.module.scss'

export const NavigationHelpLinks = () => {
  return (
    <Flex
      py={'4'}
      align={'center'}
      direction={'column'}
      gap={'5'}
    >
      <Tooltip
        content={'Help'}
        delayDuration={100}
        side='right'
        className={styles.navLinkTooltip}
      >
        <Link to={RouterPathes.help}>
          <Flex
            align={'center'}
            justify={'center'}
            className={styles.navHelpItem}
          >
            <QuestionSymbol color='var(--gray-6)' />
          </Flex>
        </Link>
      </Tooltip>
    </Flex>
  )
}
